import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const SigForm = () => {
  const [requestNumber, setRequestNumber] = useState("DHP");
  const inputRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
      const length = inputRef.current.value.length;
      inputRef.current.setSelectionRange(length, length);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!requestNumber.trim()) {
      alert("Please enter a request number.");
      return;
    }
    navigate("/sigcreate", { state: { requestNumber } });
  };

  return (
    <div className="form-container">
      <img src="/InfoMedi_logo.png" alt="Logo" className="logo" />
      <form onSubmit={handleSubmit}>
        <label
          htmlFor="requestNumber"
          style={{
            color: "#1d4ed8",
            fontWeight: "600",
            marginBottom: "4px",
            display: "block",
          }}
        >
          Request Number:
        </label>

        <input
          id="requestNumber"
          type="text"
          inputMode="numeric" 
          value={requestNumber}
          onChange={(e) => setRequestNumber(e.target.value)}
          ref={inputRef}
          style={{ width: "100%", padding: "8px", fontSize: "16px" }}
        />

        <button type="submit" className="blue-button">
          SIGNATURE
        </button>
      </form>
    </div>
  );
};

export default SigForm;
